import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'

import * as TutorialVideosActions from './tutorial-videos.actions'
import { TutorialVideosEntity } from './tutorial-videos.models'

export const TUTORIAL_VIDEOS_FEATURE_KEY = 'tutorialVideos'

export interface TutorialVideosState extends EntityState<TutorialVideosEntity> {
  selectedId?: string | number
  loaded: boolean
  showingVideo: boolean
  editCreateLoaded: boolean
}

export interface TutorialVideosPartialState {
  readonly [TUTORIAL_VIDEOS_FEATURE_KEY]: TutorialVideosState
}

export const tutorialVideosAdapter: EntityAdapter<TutorialVideosEntity> = createEntityAdapter<TutorialVideosEntity>({
  selectId: (tutorialVideosEntity: TutorialVideosEntity) => tutorialVideosEntity.uuid,
})

export const initialTutorialVideosState: TutorialVideosState = tutorialVideosAdapter.getInitialState({
  showingVideo: false,
  loaded: false,
  editCreateLoaded: true,
})

const reducer = createReducer(
  initialTutorialVideosState,
  on(TutorialVideosActions.loadTutorialVideos, (state) => ({
    ...state,
    loaded: false,
  })),
  on(TutorialVideosActions.loadTutorialVideosSuccess, (state, { tutorialVideos }) =>
    tutorialVideosAdapter.setAll(tutorialVideos, { ...state, loaded: true }),
  ),
  on(TutorialVideosActions.loadTutorialVideosFailure, (state, { error }) => ({ ...state, error, loaded: true })),
  on(TutorialVideosActions.selectTutorialVideo, (state, { uuid }) => ({ ...state, selectedId: uuid })),
  on(TutorialVideosActions.addTutorialVideoSuccess, (state, { tutorialVideo }) =>
    tutorialVideosAdapter.addOne(tutorialVideo, state),
  ),
  on(TutorialVideosActions.updateTutorialVideoSuccess, (state, { tutorialVideo }) =>
    tutorialVideosAdapter.updateOne({ id: tutorialVideo.uuid, changes: tutorialVideo }, state),
  ),
  on(TutorialVideosActions.deleteTutorialVideoSuccess, (state, { uuid }) =>
    tutorialVideosAdapter.removeOne(uuid, state),
  ),
  on(TutorialVideosActions.showTutorialPopUpVideo, (state) => ({ ...state, showingVideo: true })),
  on(TutorialVideosActions.hideTutorialPopUpVideo, (state) => ({ ...state, showingVideo: false })),
  on(TutorialVideosActions.updateTutorialVideo, TutorialVideosActions.addTutorialVideo, (state) => ({
    ...state,
    editCreateLoaded: false,
  })),
  on(
    TutorialVideosActions.updateTutorialVideoSuccess,
    TutorialVideosActions.updateTutorialVideoFailure,
    TutorialVideosActions.addTutorialVideoSuccess,
    TutorialVideosActions.addTutorialVideoFailure,
    (state) => ({
      ...state,
      editCreateLoaded: true,
    }),
  ),
)

export function tutorialVideosReducer(state: TutorialVideosState | undefined, action: Action) {
  return reducer(state, action)
}
